<template>
  <div class="missing-product">
     {{ msg ? msg : 'Missing Product/s' }}
  </div>
</template>

<script>
export default {
  name: "MissingProduct",
  props: ["msg"]
}
</script>

<style>
  .missing-product {
    text-align: center;
  }
</style>